import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { SingleCustomsDeclarationService } from '../proxy/controlling/controllers/single-customs-declaration.service';
import { FinalProductService } from '@general/proxy/general/controllers/final-product.service';
FieldBuilder.setNamespace('Controlling');

export const SINGLECUSTOMSDECLARATIONMATERIAL_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('singleCustomsDeclarationId', 'Entity.SingleCustomsDeclaration', SingleCustomsDeclarationService)
    .displayFromNested('singleCustomsDeclaration.singleCustomsDeclarationNumber')
    .sortBy('singleCustomsDeclaration.singleCustomsDeclarationNumber')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey('finalProductId', 'Entity.FinalProduct', FinalProductService)
    .queryFilter({ productCategoryName: 'Productos Diversos' })
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder.text('materialCode', 'Entity.SingleCustomsDeclarationMaterial.MaterialCode')
    .build(),
];

export const SINGLECUSTOMSDECLARATIONMATERIAL_CONFIG = {
  entityName: 'SingleCustomsDeclarationMaterial',
  localizationKey: 'Controlling::Entity.SingleCustomsDeclarationMaterial',
  fields: SINGLECUSTOMSDECLARATIONMATERIAL_FIELDS,
  permission: 'Controlling.SingleCustomsDeclarationMaterials',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
